import { Box, Stack, TextField } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import { CommentFormProps } from './types';

const CommentInlineForm = ({ value, submitLabel, onChange, onSubmit, onCancel }: CommentFormProps) => (
  <Box sx={{ mt: 2, p: 2 }}>
    <TextField
      fullWidth
      multiline
      minRows={3}
      value={value}
      onChange={event => onChange(event.target.value)}
      placeholder="Write a comment here"
    />
    <Stack direction="row" justifyContent="flex-end" gap={1} mt={2}>
      <Button variant="outlined" onClick={onCancel}>
        Cancel
      </Button>
      <Button onClick={onSubmit} disabled={!value.trim()}>
        {submitLabel}
      </Button>
    </Stack>
  </Box>
);

export default CommentInlineForm;
